import {apiGet} from "./api";

export const getListEmp = async (searchParams) => {
    return await apiGet(`/get-list-employee`, searchParams);
}
